import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  search() {
    clearTimeout(this.timeout)

    // submit the search form with a debounce timeout of 500 ms
    this.timeout = setTimeout(() => {
      this.element.requestSubmit()
    }, 500)
  }

  toggleSearchForm(event) {
    const filterForm = document.getElementById('filter-form')

    if (filterForm.classList.contains('show')) {
      const tags = event.detail.newFrame
      const element = tags.getElementsByClassName('collapse')[0]
      element.classList.add('show')
    }
  }
}
